const evite = window.evite = window.evite || {};

const promiseMap = new Map();

/**
 * @param namesOrPromises {...string|!Promise|!Array.<string|!Promise>}
 * @returns Promise
 **/
export function when(...namesOrPromises) {
  const promises = [];
  for(let nameOrPromise of namesOrPromises) {
    let promise;
    if (nameOrPromise instanceof Promise) {
      promise = nameOrPromise;
    }
    else if (typeof nameOrPromise === 'string' || Array.isArray(nameOrPromise)) {
      promise = ensurePromiseMapping(nameOrPromise).promise;
    }
    else {
      assert(false, 'Expected arguments to be either a promise, a string, or a list got: %O.', nameOrPromise);
      return null;
    }

    promises.push(promise);
  }

  if (promises.length === 1) {
    return promises[0];
  }

  return Promise.all(promises);
}

function ensurePromiseMapping(name) {
  if (!promiseMap.get(name)) {
    let mapping = createPromiseMapping();
    promiseMap.set(name, mapping);

    if (process.env.LOGGING_ENABLED) {
      mapping.promise.then((value) => {
        evite.debug('evite.resolve:', name);
      });
    }

    if (Array.isArray(name)) {
      when.apply(null, name)
        .then(resolvePromiseByName.bind(null, name))
        .catch(rejectPromiseByName.bind(null, name));
    }
  }

  return promiseMap.get(name);
}

function createPromiseMapping() {
  let mapping = {};
  mapping.promise = new Promise(function (resolve, reject) {
    mapping.resolve = resolve;
    mapping.reject = function(msgOrError){
      msgOrError = msgOrError || 'Promise rejected.';
      var error = typeof msgOrError === 'string'? new Error(msgOrError): msgOrError;
      reject(error);
    };
  });

  return mapping;
}
/**
 * @param namesOrPromise {string}
 * @param opt_value {*=} The value to send to the resolved promise
 * @returns Promise
 **/
export function resolvePromiseByName(name, opt_value) {
  let mapping = ensurePromiseMapping(name);
  mapping.resolve(opt_value);
  return mapping.promise;
}

export function resolve(dataOrName, opt_value) {
  if (typeof dataOrName === 'string') {
    return resolvePromiseByName(dataOrName, opt_value);
  }
  else {
    const nameList = [];
    for(let name in dataOrName) {
      nameList.push(name);
      resolvePromiseByName(dataOrName, dataOrName[name])
    }

    return when(nameList);
  }
}

/**
 * @param namesOrPromise {string}
 * @param opt_reason {*=} The error or message to send to the resolved promise
 * @returns Promise
 **/
export function rejectPromiseByName(name, opt_reason) {
  let mapping = ensurePromiseMapping(name);
  mapping.reject(opt_reason);
  return mapping.promise;
}

export function reject(dataOrName, opt_value) {
  if (typeof dataOrName === 'string') {
    return rejectPromiseByName(dataOrName, opt_value);
  }
  else {
    const nameList = [];
    for(let name in dataOrName) {
      nameList.push(name);
      rejectPromiseByName(dataOrName, dataOrName[name])
    }

    return when(nameList);
  }
}


let commands = window.evite.command;
when('evite').then(function(){
  if(commands){
    while(commands.length){
      const commandData = commands.shift();
      const {name, params, promiseCommand} = commandData;

      var promise = exports[name].apply(evite, params);

      for(let promiseCommandData of promiseCommand){
        const {name, params} = promiseCommandData;
        promise[name].apply(promise, params);
      }
    }
  }
});

Object.assign(evite, exports);



// WEBPACK FOOTER //
// ./assets/es6/common/evite/when.es6